import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../../layoutcontainers/DashboardLayout'
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormHelperText, Grid, Snackbar, Stack } from '@mui/material'
import MaterialTypography from '../../../components/MaterialTypography'
import MaterialButton from '../../../components/MaterialButton'
import SimpleTable from '../../../components/SimpleTable'
import MaterialInput from '../../../components/MaterialInput'
import AddIcon from '@mui/icons-material/Add';
import axios from 'axios'
import { BASE_URL, fetchData, fetchDataById } from '../../Utils/Baseurl'
import { useLoading } from '../../../context/loadingcontext'
import { useNavigate } from 'react-router-dom'


const DepartmentMaster = () => {

  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [departmentData, setDepartmentData] = useState({
    departmentName: '',
    departmentCode: '',
    departmentNameStatus: 'unchecked',
    departmentCodeStatus: 'unchecked',
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'info',
  });
  const [departmentList, setDepartmentList] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [pages, setPages] = useState({
    view: false,
    edit: false,
    id: "",
  });
  const [editID, setEditID] = useState(0);


  useEffect(() => {
    fetchDepartmentList();
  }, []);


  const fetchDepartmentList = async () => {
    setCirleLoading(true);
    try {
      const response = await fetchData("api/department/");

      if (response?.status && Array.isArray(response.data)) {
        setDepartmentList(response.data);
      } else {
        setDepartmentList([]);
      }
      setCirleLoading(false);
    } catch (error) {
      console.error("Error while fetching team list:", error);
      setCirleLoading(false);
    }
  }

  const editDepartment = async (row) => {
    handleDialogOpen();
    setPages({
      view: false,
      edit: true,
      id: row,
    });
    try {
      const response = await fetchDataById(`api/department/${row}/`);
      setEditID(response.data.id);
      if (response.status) {
        setDepartmentData((prev) => ({
          ...prev,
          departmentName: response?.data?.department_name,
          departmentCode: response?.data?.department_code,
          departmentNameStatus: 'success',
          departmentCodeStatus: 'success',
        }))
      }
    } catch (error) {
      console.error("Error fetching team data:", error);
    }
  };


  const handleChange = (e) => {
    const { name, value } = e.target;

    const updatedData = { ...departmentData };

    const validateName = (name) => {
      const nameRegex = /^[A-Za-z\s]+$/;
      return nameRegex.test(name) && name.trim().length > 0;
    };

    const validateCode = (email) => {
      const descRegex = /^[A-Za-z0-9\s]+$/;
      return descRegex.test(email);
    };

    switch (name) {
      case 'employeename':
        updatedData.departmentName = value;
        updatedData.departmentNameStatus = validateName(value) ? 'success' : 'error';
        break;

      case 'employeemail':
        updatedData.departmentCode = value;
        updatedData.departmentCodeStatus = validateCode(value) ? 'success' : 'error';
        break;

      default:
        break;
    }

    setDepartmentData(updatedData);
  };

  const handleSubmitDepartment = async () => {
    setCirleLoading(true);
    const { departmentName, departmentCode } = departmentData;
    try {
      const token = sessionStorage.getItem('token');
      if (!token) throw new Error('No token found');

      const formData = new FormData();
      formData.append('department_name', departmentName);
      formData.append('department_code', departmentCode);

      const response = await axios.post(
        `${BASE_URL}api/department/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response.data, 'response');
      setDialogOpen(false);
      setDepartmentData({
        departmentName: '',
        departmentCode: '',
      })
      navigate('/dashboards/department-master');
      fetchDepartmentList();
      setSnackbar({
        open: true,
        message: 'Department created successfully!',
        severity: 'success',
      });
      setPages({
        edit: false,
      });
    } catch (error) {
      console.error('Error posting department data:', error);
    } finally {
      setCirleLoading(false);
    }
  };

  const handleUpdateDepartment = async () => {
    const { departmentName, departmentCode } = departmentData;
    try {
      const token = sessionStorage.getItem('token');
      if (!token) throw new Error('No token found');

      const formData = new FormData();
      formData.append('department_name', departmentName);
      formData.append('department_code', departmentCode);

      const response = await axios.put(
        `${BASE_URL}api/department/${editID}/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setDialogOpen(false);
      setDepartmentData({
        departmentName: '',
        departmentCode: '',
      })
      setSnackbar({
        open: true,
        message: 'Department updated successfully!',
        severity: 'success',
      });
      // navigate('/dashboards/department-master');
      fetchDepartmentList();
    } catch (error) {
      console.error('Error posting department data:', error);
    }

  }


  const handleDelete = (row) => {
    setSelectedRow(row);
    setOpen(true);
  };

  const handleConfirmDelete = () => {
    try {
      const token = sessionStorage.getItem('token');
      const response = axios.delete(`${BASE_URL}api/department/${selectedRow}/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      console.log(response.data, 'response');
    } catch (error) {
      console.log(error)
    }
    setOpen(false);
    setSelectedRow(null);
    fetchDepartmentList();
  };

  const handleCancel = () => {
    setOpen(false);
    setSelectedRow(null);
  };

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const departmentTable = {
    columns: [
      {
        key: "department",
        header: "Department Name",
      },
      {
        key: "departmentCode",
        header: "Department Code",
      },
      { header: "ACTION", key: "action" },
    ],
    row: departmentList?.map((item) => ({
      id: item?.id,
      department: item?.department_name.replace(/_/g, " "),
      departmentCode: item?.department_code.replace(/_/g, " "),
    })),
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <DashboardLayout>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        p={1}
        mb={2}
      >
        <Stack direction="column" spacing={0}>
          <MaterialTypography variant="h5" fontWeight="bold" color='dark'>
            Department Master
          </MaterialTypography>
          <MaterialTypography variant="caption" color="text">
            You can view the department list here.
          </MaterialTypography>
        </Stack>

        <MaterialButton
          variant="gradient"
          color="dark"
          size="small"
          startIcon={<AddIcon />}
          onClick={handleDialogOpen}
        >
          Add Department
        </MaterialButton>
      </Stack>

      <SimpleTable columns={departmentTable?.columns} data={departmentTable?.row} onEdit={editDepartment} onDelete={handleDelete} view={false}  />

      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        aria-labelledby="new-employee-dialog-title"
        sx={{ '& .MuiDialog-paper': { width: '600px', maxWidth: '90%' } }}
      >
        <DialogTitle id="new-employee-dialog-title">{pages.edit === true ? 'Edit Department' : 'Add New Department'}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Stack direction='column' spacing={1}>
                <MaterialTypography variant='caption' color='text'>Department Name<span style={{ color: 'red' }}>*</span></MaterialTypography>
                <MaterialInput
                  name="employeename"
                  placeholder="Enter Department Name"
                  value={departmentData.departmentName}
                  onChange={handleChange}
                  error={departmentData.departmentNameStatus === "error"}
                  success={departmentData.departmentNameStatus === "success"}
                />
                {
                  (departmentData.departmentNameStatus === "error") && (
                    <FormControl error style={{ marginTop: '0px' }}>
                      <FormHelperText>
                        The department name should contains only alphabets.
                      </FormHelperText>
                    </FormControl>
                  )
                }
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Stack direction='column' spacing={1}>
                <MaterialTypography variant='caption' color='text'>Department Code<span style={{ color: 'red' }}>*</span></MaterialTypography>
                <MaterialInput
                  name="employeemail"
                  placeholder="Enter Department Code"
                  value={departmentData.departmentCode}
                  onChange={handleChange}
                  error={departmentData.departmentCodeStatus === "error"}
                  success={departmentData.departmentCodeStatus === "success"}
                />
                {
                  (departmentData.departmentCodeStatus === "error") && (
                    <FormControl error style={{ marginTop: '0px' }}>
                      <FormHelperText>
                        Department code should be alphanumeric.
                      </FormHelperText>
                    </FormControl>
                  )
                }
              </Stack>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <MaterialButton onClick={handleDialogClose} color="primary">
            Cancel
          </MaterialButton>
          <MaterialButton onClick={pages.edit === true ? handleUpdateDepartment : handleSubmitDepartment} color="dark" variant="contained">
            {pages.edit === true ? 'Update' : 'Save'}
          </MaterialButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this department?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="primary">
            Cancel
          </Button>
          <MaterialButton onClick={handleConfirmDelete} color="red">Delete</MaterialButton>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>

    </DashboardLayout>
  )
}

export default DepartmentMaster
